
(function ($) {
  $(document).ready(function(){
    var arrow = ["<button class='prev--control slide--control' data-slide-control='previous'>Previous</button>" ,"<button class='next--control slide--control' data-slide-control='next'>Next</button>"]

    $(".owl-carousel").owlCarousel({
      loop:true,
      margin:0,
      nav:true,
      smartSpeed: 800, // duration of change of 1 slide,
      dotsContainer: '#carousel-custom-dots',
      autoHeight:true,
      navText: arrow,
      animateOut: 'fadeOut',
      lazyLoad: true,
      responsive:{
        0:{
          items:1
        },
        600:{
          items:1
        },
        1000:{
          items:1
        }
      }
    });
  });

})(jQuery);


